var KeywordBar, base, placeholderState, unparam, whichKeyAlias;

unparam = require('../../general/m_unparam');

whichKeyAlias = require('../common/m_keypress').whichKeyAlias;

placeholderState = require('../helper/m_common').placeholderState;

module.exports = KeywordBar = (function() {
  function KeywordBar(arg) {
    var el, env, initialKeyword;
    el = arg.el, env = arg.env;
    this.$el = el;
    this.env = env || 'desktop';
    this.$input = this.$el.find('#search, #ls-search');
    this.placeholder = this.$input.attr('placeholder');
    this.bind();
    if (!_.isBlank(initialKeyword = unparam().query)) {
      placeholderState.set(this.$input, 'hide');
      this.val(initialKeyword);
    }
    return;
  }

  KeywordBar.prototype.bind = function() {
    return this.$input.on('keydown', (function(_this) {
      return function(e) {
        if (whichKeyAlias(e) === 'Enter') {
          _this.$el.trigger('submit');
        }
      };
    })(this));
  };

  KeywordBar.prototype.setKeyword = KeywordBar.val;

  KeywordBar.prototype.val = function(value) {
    var currentVal;
    if (value != null) {
      return this.$input.val(value).removeClass('prompting');
    } else {
      currentVal = this.$input.val();
      if (_.isBlank(currentVal) || currentVal === this.placeholder) {
        return null;
      }
      return currentVal.trim();
    }
  };

  return KeywordBar;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, {
  KeywordBar: KeywordBar
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL3NlYXJjaC92aWV3L21fa2V5d29yZF9iYXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL3NlYXJjaC92aWV3L21fa2V5d29yZF9iYXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsT0FBQSxHQUF1QixPQUFBLENBQVEseUJBQVI7O0FBQ3JCLGdCQUFxQixPQUFBLENBQVEsc0JBQVI7O0FBQ3JCLG1CQUFxQixPQUFBLENBQVEsb0JBQVI7O0FBRXZCLE1BQU0sQ0FBQyxPQUFQLEdBQXVCO0VBQ1Isb0JBQUMsR0FBRDtBQUNYLFFBQUE7SUFEYSxhQUFJO0lBQ2pCLElBQUMsQ0FBQSxHQUFELEdBQU87SUFDUCxJQUFDLENBQUEsR0FBRCxHQUFPLEdBQUEsSUFBTztJQUNkLElBQUMsQ0FBQSxNQUFELEdBQVUsSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQVUscUJBQVY7SUFDVixJQUFDLENBQUEsV0FBRCxHQUFlLElBQUMsQ0FBQSxNQUFNLENBQUMsSUFBUixDQUFhLGFBQWI7SUFFZixJQUFDLENBQUEsSUFBRCxDQUFBO0lBRUEsSUFBQSxDQUFPLENBQUMsQ0FBQyxPQUFGLENBQVUsY0FBQSxHQUFpQixPQUFBLENBQUEsQ0FBUyxDQUFDLEtBQXJDLENBQVA7TUFDRSxnQkFBZ0IsQ0FBQyxHQUFqQixDQUFxQixJQUFDLENBQUEsTUFBdEIsRUFBOEIsTUFBOUI7TUFDQSxJQUFDLENBQUEsR0FBRCxDQUFLLGNBQUwsRUFGRjs7QUFHQTtFQVhXOzt1QkFhYixJQUFBLEdBQU0sU0FBQTtXQUNKLElBQUMsQ0FBQSxNQUFNLENBQUMsRUFBUixDQUFXLFNBQVgsRUFBc0IsQ0FBQSxTQUFBLEtBQUE7YUFBQSxTQUFDLENBQUQ7UUFDcEIsSUFBRyxhQUFBLENBQWMsQ0FBZCxDQUFBLEtBQW9CLE9BQXZCO1VBQ0UsS0FBQyxDQUFBLEdBQUcsQ0FBQyxPQUFMLENBQWEsUUFBYixFQURGOztNQURvQjtJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBdEI7RUFESTs7dUJBTU4sVUFBQSxHQUFZLFVBQUMsQ0FBQTs7dUJBRWIsR0FBQSxHQUFLLFNBQUMsS0FBRDtBQUNILFFBQUE7SUFBQSxJQUFHLGFBQUg7YUFDRSxJQUFDLENBQUEsTUFDQyxDQUFDLEdBREgsQ0FDTyxLQURQLENBRUUsQ0FBQyxXQUZILENBRWUsV0FGZixFQURGO0tBQUEsTUFBQTtNQUtFLFVBQUEsR0FBYSxJQUFDLENBQUEsTUFBTSxDQUFDLEdBQVIsQ0FBQTtNQUViLElBQWUsQ0FBQyxDQUFDLE9BQUYsQ0FBVSxVQUFWLENBQUEsSUFBeUIsVUFBQSxLQUFjLElBQUMsQ0FBQSxXQUF2RDtBQUFBLGVBQU8sS0FBUDs7YUFDQSxVQUFVLENBQUMsSUFBWCxDQUFBLEVBUkY7O0VBREc7Ozs7Ozs7TUFhZSxDQUFDLFlBQWE7OztBQUNwQyxDQUFDLENBQUMsTUFBRixDQUFTLE1BQU0sQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLFNBQWhDLEVBQTJDO0VBQUMsWUFBQSxVQUFEO0NBQTNDIn0=
